/* import React, { useState, useEffect } from 'react'
import { NextSeo } from 'next-seo'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useRouter } from 'next/router'
import { toast } from 'react-toastify'

import { Column, Button, Input, Checkbox, Dropzone, Text, UploadButton, Row } from 'components'
import { CheckboxContainer } from 'routes/WorkWithUs/styles'

import { getAreaTypes, createWorkWithUs } from 'services/workWithUs'
import { WorkWithUsResolver } from 'helpers/yupSchemas'

import { useUser } from 'context/user-context'

const defaultValues = { name: '', email: '', type: '', subject: '', body: '', file: '', area_type_ids: '' }

const WorkWIthUs = () => {
  const { user } = useUser()
  const router = useRouter()

  const [logged, setLogged] = useState(false)
  const [areaTypes, setAreaTypes] = useState([])
  const [isResponsive, setIsResponsive] = useState(false)

  const {
    control,
    handleSubmit,
    errors,
    formState: { isSubmitting },
    setValue
  } = useForm({
    mode: 'onBlur',
    defaultValues,
    resolver: yupResolver(WorkWithUsResolver)
  })

  const onSubmit = async data => {
    try {
      const body = {
        name: data.name,
        email: data.email,
        subject: data.subject,
        body: data.body,
        file: data.file,
        area_type_ids: Object.values(data.area_type_ids)
          .map((item, index) => (item ? index + 1 : null))
          .filter(value => value != null)
      }

      const formData = new FormData()
      formData.append('name', body.name)
      formData.append('email', body.email)
      formData.append('subject', body.subject)
      formData.append('body', body.body)
      formData.append('file', body.file[0])
      body.area_type_ids.forEach(areaId => formData.append('area_type_ids', areaId))

      await createWorkWithUs(formData)
      router.push('/agradecemos-interesse')
    } catch (error) {
      toast.error('Erro ao entrar em contato. Tente novamente')
    }
  }

  const handleDrop = files => {
    setValue('file', files)
  }

  const handleDelete = () => {
    setValue('file', '')
  }

  useEffect(() => {
    const fetchInfos = async () => {
      try {
        const response = await getAreaTypes()
        setAreaTypes(
          response.filter(item => {
            if (item.name != 'CEO' && item.name != 'COO' && item.name != 'Financeiro') {
              return item
            }
          })
        )
      } catch (error) {
        toast.error('Ocorreu um erro ao carregar dados. Tente novamnete')
      }
    }

    fetchInfos()
    setIsResponsive(window.innerWidth > 1150)
  }, [])

  useEffect(() => {
    if (!!user) {
      setLogged(true)
    }
  }, [user, setLogged])

  return (
    <Column alignItems='center' width='100%' pt={logged ? '152px' : '112px'} pl={2} pr={2}>
      <NextSeo title={'Kavod Lending | Trabalhe Conosco'} description='KavodLending | Work with us' />
      <form onSubmit={handleSubmit(onSubmit)} encType='multipart/form-data'>
        <Column>
          <Text variant='h3' mb={4}>
            Trabalhe conosco
          </Text>
          <Input
            mb='40px !important'
            id='name'
            label='Nome completo'
            name='name'
            placeholder='Nome'
            control={control}
            error={errors.name}
          />
          <Input
            mb='40px !important'
            id='email'
            label='E-mail'
            name='email'
            placeholder='Email'
            control={control}
            error={errors.email}
          />
          <Input
            mb='40px !important'
            id='subject'
            label='Assunto'
            name='subject'
            placeholder='Assunto'
            control={control}
            error={errors.subject}
          />
          <Input
            control={control}
            name='body'
            label='Por que você quer trabalhar na Kavod?'
            multiline
            minRows={3}
            maxRows={10}
            error={errors.body}
          />
          <Text variant='subtitle2' mt={3} mb={2} style={{ color: 'gray.800' }}>
            Áreas de interesse
          </Text>
          <CheckboxContainer>
            {areaTypes.map(({ name }) => (
              <Checkbox control={control} key={name} name={`area_type_ids.${name}`} label={name} />
            ))}
          </CheckboxContainer>
          {errors.area_type_ids && (
            <Text variant='subtitle1' color='error'>
              Campo obrigatório.
            </Text>
          )}
          <Row mt={4} mb={2}>
            <Text variant='subtitle2' style={{ color: 'gray.800' }} mr={1}>
              Currículo
            </Text>
            <Text variant='subtitle1' style={{ color: '#9E9E9E' }}>
              (Tamanho máximo: 5MB)
            </Text>
          </Row>

          {!isResponsive ? (
            <UploadButton name='file' control={control} onDrop={handleDrop} onDelete={handleDelete} />
          ) : (
            <Dropzone name='file' control={control} onDrop={handleDrop} onDelete={handleDelete} />
          )}
          {errors.file && (
            <Text variant='subtitle1' color='error'>
              Campo obrigatório
            </Text>
          )}
          <Button width='100%' mb={4} mt={4} type='submit' loader={isSubmitting}>
            Enviar
          </Button>
        </Column>
      </form>
    </Column>
  )
}

export default WorkWIthUs
 */

import { Column } from '../src/components'

const WorkWIthUs = () => {
  return <Column alignItems='center' width='100%' paddingTop='16vh' pl={2} pr={2} />
}

export default WorkWIthUs
